import { render, staticRenderFns } from "./CreateFilter.vue?vue&type=template&id=30c2bff2&"
import script from "./CreateFilter.vue?vue&type=script&lang=js&"
export * from "./CreateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c2bff2')) {
      api.createRecord('30c2bff2', component.options)
    } else {
      api.reload('30c2bff2', component.options)
    }
    module.hot.accept("./CreateFilter.vue?vue&type=template&id=30c2bff2&", function () {
      api.rerender('30c2bff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/GlobalFilters/CreateFilter.vue"
export default component.exports